import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { deleteRating } from "@/Services/TherapyApi/Agent";

import useAgentStore from "@/Modules/Agent/Store";
import useAppStore from "@/Modules/App/Store";

async function deleteRatingAH(ratingId: string) {
  const appStore = useAppStore();
  const agentStore = useAgentStore();

  agentStore.isSavingRating = true;

  try {
    await deleteRating(ratingId);

    agentStore.setRatingModalVisible(null);
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    agentStore.isSavingRating = false;
  }
}

export default deleteRatingAH;
